import { render, staticRenderFns } from "./ThankyouView.vue?vue&type=template&id=03268715"
import script from "./ThankyouView.vue?vue&type=script&lang=js"
export * from "./ThankyouView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports